/**
 * Platform feature-flag codes, mirroring backend `FeatureFlagCodes`.
 * `GET /api/v1/feature-flags` returns the flat list of ACTIVE codes —
 * absence means off. Never inline these strings.
 */
export const FeatureFlagCodes = {
  paidAmenities: 'PAID_AMENITIES',
  events: 'EVENTS',
  tournaments: 'TOURNAMENTS',
  googlePay: 'GOOGLE_PAY',
  coaching: 'COACHING',
} as const;

export type FeatureFlagCode = (typeof FeatureFlagCodes)[keyof typeof FeatureFlagCodes];
